import { useState } from "react";
import { Label } from "@/components/ui/atoms/label";
import { cn } from "@/lib/utils";
import { getVisualLevel, saveVisualLevel, VISUAL_LEVELS } from "@/lib/visuals-pref";

/** Settings → AI → Visuals (ADMIN-204): how often an answer shows a table or chart. */
export function VisualsSetting() {
  const [level, setLevel] = useState(getVisualLevel);
  const current = VISUAL_LEVELS.find((option) => option.id === level);

  return (
    <div className="rounded-lg border p-4 space-y-3">
      <div>
        <Label className="text-sm font-semibold">Visuals in answers</Label>
        <p className="text-xs text-muted-foreground mt-1">
          How often an answer draws a table or chart instead of describing the numbers.
        </p>
      </div>
      <fieldset aria-label="Visuals in answers" className="flex gap-1 rounded-lg bg-muted p-1">
        {VISUAL_LEVELS.map((option) => (
          <button
            key={option.id}
            type="button"
            aria-pressed={level === option.id}
            onClick={() => {
              saveVisualLevel(option.id);
              setLevel(option.id);
            }}
            className={cn(
              "flex-1 rounded-md px-3 py-2 text-sm font-medium transition-colors",
              level === option.id
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {option.name}
          </button>
        ))}
      </fieldset>
      <p className="text-xs text-muted-foreground">
        {current?.description}. Applies to your next message.
      </p>
    </div>
  );
}
